import { render, staticRenderFns } from "./TheError.vue?vue&type=template&id=3be88172&scoped=true&"
import script from "./TheError.vue?vue&type=script&lang=js&"
export * from "./TheError.vue?vue&type=script&lang=js&"
import style0 from "./TheError.vue?vue&type=style&index=0&id=3be88172&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be88172",
  null
  
)

export default component.exports